/** P4 route: loads the views the cockpit reads (`teamState`, `roundReport` for the last two released rounds, `publicMarket`, catalog, welcome). */
import { useCohortData } from "../shell/data";
import { GxErrorBanner, GxWaiting } from "../theme/primitives";
import { Cockpit } from "./Cockpit";

export function CockpitPage({ cohortId, teamId }: { readonly cohortId: string; readonly teamId: string | null }) {
  const data = useCohortData(cohortId, teamId, 2);
  if (data.error !== null) return <GxErrorBanner error={data.error} />;
  if (data.status === "no-team") return <GxErrorBanner message="Your facilitator hasn't placed you on a team yet." />;
  if (data.status === "loading") return <CockpitSkeleton />;
  return <Cockpit team={data.team} catalog={data.catalog} market={data.market} reports={data.reports} bankName={data.welcome.bankName} cohortId={cohortId} userId={data.userId} />;
}

/** The final layout in outline, never zeros (screens §3.1). */
function CockpitSkeleton() {
  return <GxWaiting what="your bank's latest figures" testId="cockpit.skeleton" height={460} />;
}
